import { PageRender } from "@/components/layout/frontend/page"

/**
 * Page: LegalNotice
 */
const LegalNotice: React.FC = () => {
  return <PageRender pageKey="legalNotice" />
}
export default LegalNotice
